export const GET_SUPPLIER = 'GET_SUPPLIER';
export const AUTH_SUCCESSFUL = 'AUTH_SUCCESSFUL';
export const LOGOUT = 'LOGOUT';

export const EMPTY_NOTIFICATION = 'EMPTY_NOTIFICATION';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';

export const UPDATE_BLOCKED_TIME = 'UPDATE_BLOCKED_TIME';
export const UPDATE_HERE_TOKEN = 'UPDATE_HERE_TOKEN';
export const FAILED_FETCHING_SUPPLIER = 'FAILED_FETCHING_SUPPLIER';